"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compactRolEchainMock = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
const KetteSerieType_1 = require("../kette/KetteSerieType");
exports.compactRolEchainMock = {
    ArticleType: echain_product_models_1.ArticleType.kette,
    KetteSerieType: KetteSerieType_1.KetteSerieType.rolEchain,
    SerieRef: {
        Id: 123,
    },
    ArtNr: {
        DE: 'a.b.1.0',
    },
    Bezeichnung: {
        'de-DE': 'Rollenglied',
        'en-GB': 'rolLink',
    },
    LangerWeg: true,
    StandardLinkRef: 'a.b.2.0',
    AdapterLinkRef: 'a.b.3.0',
    Teilung_mm: 145,
    WeightPerLink_g: 198.38,
    NumFirstOtherLinks: 3,
    Innenhoehe_mm: 1,
    Innenbreite_mm: 1,
    Aussenhoehe_mm: 3,
    Aussenbreite_mm: 3,
    K2_mm: 2184,
    Id: 123456789,
    LeitungDiameterMax_mm: 50,
    Biegeradius_mm: 300,
    GleitenderBetriebErlaubt: true,
};
//# sourceMappingURL=compactRolEchain.mock.js.map